<template>
  <b-modal
    title="Nuevo Documento Predefinido"
    v-model="showModal"
    hide-footer
    centered
  >
    <div class="row">
      <div class="col-md-12">
        ¿Qué tipo de documento quieres crear?
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <b-form-select
          v-model="type"
          :options="optionsTypeDocument"
        />
      </div>
    </div>
    <div class="row pt-2">
      <div class="col-md-12 d-flex justify-end">
        <vs-button
          radius
          v-tooltip="'Crear documento predefinido'"
          class="action mr-2"
          color="primary"
          @click="goToForm"
          :disabled="type === ''"
          data-cy="create"
        >Crear</vs-button>
      </div>
    </div>

  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import RepositoriesCustomTypeMixin from '@/febos/chile/commons/mixins/RepositoriesCustomTypeMixin';

export default {
  name: 'NewCustomDocument',
  props: {
  },
  mixins: [RepositoriesCustomTypeMixin],
  data() {
    return {
      type: 'ADP',
    };
  },
  components: {

  },
  mounted() {
  },
  created() {
    if (this.isGoreVal) {
      this.setTypeDocument('ACUCORE');
    } else if (this.isSissVal) {
      this.setTypeDocument('AF');
    } else if (this.isUAysenVal) {
      this.setTypeDocument('SCH');
    } else if (this.isMachaliVal) {
      this.setTypeDocument('DA');
    }
  },
  methods: {
    ...mapActions('Modals', [
      'closeModal'
    ]),
    goToForm() {
      this.$router.push({
        name: 'edit-custom-document',
        params: { type: this.type },
        query: {
          locationType: this.getSelectedRepositoryId ? 'root' : 'folder',
          locationId: this.getSelectedRepositoryId || this.getSelectedFolderId
        }
      });
    },
    setTypeDocument(type) {
      this.type = type;
    }
  },
  computed: {
    ...mapGetters('Modals', [
      'modalName'
    ]),
    ...mapGetters('DocManagement', [
      'getSelectedRepositoryId',
      'getSelectedFolderId',
      'getSelectedElement',
      'getTreeElements',
      'getRepositories'
    ]),
    ...mapGetters('Empresas', [
      'company'
    ]),
    showModal: {
      get() {
        return this.modalName === 'newCustomDocument';
      },
      set() {
        this.closeModal();
      }
    },
  }
};
</script>
